import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { BookOpen, Heart, Shield } from 'lucide-react';
export function AboutBook() {
  return <section className="bg-warm-beige py-24 px-6 relative" data-id="element-23">
      <div className="max-w-4xl mx-auto text-center" data-id="element-24">
        <AnimatedSection data-id="element-25">
          <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-26">
            Sobre el Libro
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-medium-brown mb-12" data-id="element-27">
            Este libro es un refugio seguro para quienes han llevado el peso del
            silencio durante demasiado tiempo. A través de páginas llenas de
            compasión y entendimiento, exploramos el viaje de sanación desde las
            heridas de la infancia hacia un futuro de empoderamiento y paz
            interior. No estás solo, y tu historia importa.
          </p>
        </AnimatedSection>

        <AnimatedSection stagger className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-28">
          <div className="bg-white/60 backdrop-blur-sm p-8 rounded-2xl shadow-warm flex flex-col items-center text-center" data-id="element-29">
            <div className="w-16 h-16 bg-amber/20 rounded-full flex items-center justify-center mb-6 text-terracotta" data-id="element-30">
              <Heart size={32} data-id="element-31" />
            </div>
            <h3 className="text-xl font-semibold mb-4" data-id="element-32">Sanación Profunda</h3>
            <p className="text-medium-brown" data-id="element-33">
              Encuentra el espacio para procesar emociones reprimidas con
              gentileza y sin juicios.
            </p>
          </div>

          <div className="bg-white/60 backdrop-blur-sm p-8 rounded-2xl shadow-warm flex flex-col items-center text-center" data-id="element-34">
            <div className="w-16 h-16 bg-amber/20 rounded-full flex items-center justify-center mb-6 text-terracotta" data-id="element-35">
              <BookOpen size={32} data-id="element-36" />
            </div>
            <h3 className="text-xl font-semibold mb-4" data-id="element-37">Romper el Ciclo</h3>
            <p className="text-medium-brown" data-id="element-38">
              Aprende a identificar patrones del pasado para construir un futuro
              libre y auténtico.
            </p>
          </div>

          <div className="bg-white/60 backdrop-blur-sm p-8 rounded-2xl shadow-warm flex flex-col items-center text-center" data-id="element-39">
            <div className="w-16 h-16 bg-amber/20 rounded-full flex items-center justify-center mb-6 text-terracotta" data-id="element-40">
              <Shield size={32} data-id="element-41" />
            </div>
            <h3 className="text-xl font-semibold mb-4" data-id="element-42">Empoderamiento</h3>
            <p className="text-medium-brown" data-id="element-43">
              Recupera tu voz, establece límites saludables y redescubre tu
              fuerza interior.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}